import { createContext, useState, useContext } from 'react';

const ModalContext = createContext<any>(null);

export const ModalProvider = ({ children }: any) => {
  const [modal, setModal] = useState<any>(null);

  const openModal = (name: string, props = {}) => {
    setModal({ name, props });
  };

  const closeModal = () => setModal(null);

  return (
    <ModalContext.Provider value={{ modal, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
